/**
 * 返回 [ min, max ] 之间的整数
 * @param min 包含的最小值
 * @param max 包含的最大值
 */
export function randNum(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export enum token {
  number = '0123456789',
  lowercase = 'abcdefghijklmnopqrstuvwxyz',
  uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXY',
  alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXY',
  all = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
  enhance = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ~!@#$%^&*()-_=+[]{}|<>?'
}

/**
 * 返回随机字符串
 * @param length 字符串长度
 * @param tokens 字符串词库，未传入值时默认 number + alphabet
 */
export function randStr(length: number, tokens: token | string = token.all) {
  return [...Array(length)]
    .map(() => tokens[randNum(0, tokens.length)])
    .join('')
}

/**
 * 生成随机不重复的 Key
 */
export const randKey = (() => {
  const keys = new Set<string>()
  let len = 5
  return () => {
    if (keys.size > 0.3 * Math.pow(10, len)) {
      len++
    }

    let key = randStr(len, token.all)
    while (keys.has(key)) {
      key = randStr(len, token.all)
    }
    keys.add(key)
    return `_${key}`
  }
})()
